import { GET_THEME, THEME_LOADING, SET_THEME, SIDEBAR_VISIBILITY } from '../actions/types'

const initialState = {
  palette: null,
  loading: true,
  sidebarVisibility: true,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case THEME_LOADING:
      return {
        ...state,
        loading: true,
      }
    case SET_THEME:
      return {
        ...state,
        palette: action.payload,
        loading: false,
      }
    case GET_THEME:
      return {
        ...state,
        palette: action.payload,
        loading: false,
      }
    case SIDEBAR_VISIBILITY:
      return {
        ...state,
        loading: false,
        sidebarVisibility: action.payload,
      }
    default:
      return state
  }
}
